import { SdkConfig } from '@criptalia/sdk/src/Sdk'

const wsProtocol = import.meta.env.VITE_API_URL.search(/^https:/) > -1 ? 'wss://' : 'ws://'

const websocketUrl = wsProtocol + import.meta.env.VITE_API_DOMAIN + '/connection/websocket'

const isProduction = window.location.host.endsWith('october.evenfi.com')
const comingSoonEnabled = import.meta.env.VITE_COMING_SOON === 'true'
const comingSoonBypassPassword = import.meta.env.VITE_COMING_SOON_BYPASS_PASSWORD || 'october2024'

export const FRONTEND_ENV: SdkConfig['env'] = {
  isProduction,
  isProductionBuild: import.meta.env.PROD,
  websocketUrl,
  brandName: 'october',
  comingSoonEnabled,
  comingSoonBypassPassword,
  datocmsToken:
    import.meta.env.VITE_DATO_CMS_TOKEN || '372b29568e0feb1478af9ea8a33ea2',
  mapsApiKey:
    import.meta.env.VITE_MAPS_API_KEY ||
    'AIzaSyB15ds5CBvNKu8VGdxMxKp7nVPPLYtqQkM',
}
